import { useQueryClient } from '@tanstack/vue-query';

import { isUserOnboarded, type Profile, profileKeys } from '@/entities/profile';

export function onboardingGuard() {
  const queryClient = useQueryClient();

  const profile = queryClient.getQueryData<Profile>(profileKeys.profile());

  if (isUserOnboarded(profile)) {
    return {
      name: 'profile',
    };
  }
}
